import { render, staticRenderFns } from "./CrearTipoDatoExtendidoModal.vue?vue&type=template&id=6d7513ae&scoped=true&"
import script from "./CrearTipoDatoExtendidoModal.vue?vue&type=script&lang=ts&"
export * from "./CrearTipoDatoExtendidoModal.vue?vue&type=script&lang=ts&"
import style0 from "./CrearTipoDatoExtendidoModal.vue?vue&type=style&index=0&id=6d7513ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7513ae",
  null
  
)

export default component.exports